<template>
  <div>
    <section class="main home-section margin-top-150 mt-5 text-white">
      <div class="d-flex flex-column-reverse flex-md-row">
        <div
          class="d-flex flex-column justify-content-center align-items-start p-3"
        >
          <h4 class="f-secondary t-secondary p-2">Have questions or want to get involved…we’d love to hear from you?</h4>
          <div class="d-flex justify-content-start p-2">
            <button class="btn btn-primary" @click="goToEnquiry()">
              Enquire Here
            </button>
          </div>
        </div>
        <div class="col-12 col-md-6 margin-top-n-45">
          <img src="../../../public/img/stm/cta-banner.png" class="img-fluid" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  methods: {
    goToEnquiry() {
      this.$router.push("/tfm/enquiry-form");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../src/assets/scss/stm.scss";
.fs-50px {
  font-size: 50px !important;
}
</style>
